import React, {useEffect} from 'react';

import {useApi} from "../../providers/ApiProvider";
import {Navigate, useParams} from "react-router-dom";
import {useNotifications} from "../../providers/NotificationsProvider";
import ProjectsRequests from "../../requests/ProjectsRequests";
import {useAuth} from "../../providers/AuthProvider";
import UsersRequests from "../../requests/UsersRequests";
import ProjectView from "./ProjectView";

export default function ProjectViaLink({}) {
    const {projectId, accessToken} = useParams();
    const apiContext = useApi();
    const authContext = useAuth();
    const projectsRequests = new ProjectsRequests(apiContext.api);
    const userModel = new UsersRequests(apiContext.api);
    const notifications = useNotifications();

    const [token, setToken] = React.useState('');


    useEffect(() => {

        projectsRequests.validate(projectId, accessToken, uploadErrorHandler).then((response) => {
            if (response !== false) {
                setToken(accessToken);
            } else {
                notifications.notify('Invalid link!', 'error');
                window.location.href = '/404';
            }
        });
    }, []);


    const uploadErrorHandler = (response) => {
        if (response.data && response.data[0].error) {
            notifications.notify('Loading error!', 'error');
        }
    }


    return token ? (
        <ProjectView accessToken={token} />
    ) : 'Loading...';
}
